// extracted by mini-css-extract-plugin
export var actions = "_98-8";
export var arrow = "_98-5";
export var card = "_98-0";
export var cardWrapper = "_98-9";
export var fieldName = "_98-3";
export var newValue = "_98-6";
export var oldValue = "_98-4";
export var orangeGlowFade = "_98-c";
export var productSection = "_98-1";
export var scrollToBottom = "_98-b";
export var scrollToBottomAnchor = "_98-a";
export var scrollToBottomIcon = "_98-d";
export var showAllButton = "_98-7";
export var table = "_98-2";